import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textDescription'
})
export class TextDescriptionPipe implements PipeTransform {
  limit = 175;

  transform(value: string): string {
    const descriptionSplit = value?.split(' ');
    let description = '';

    const descriptionMin = descriptionSplit?.splice(0, 25).join(' ');

    value?.length < this.limit ?
      description = value :
      description = descriptionMin + '...';

    return description;
  }

}
